import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { registerDevice } from "../api/devices"
import { useDeviceStore, generateUuid } from "../state/deviceStore"
import { ApiClientError } from "../api/client"

export default function DeviceSetupPage() {
  const navigate = useNavigate()
  const register = useDeviceStore(s => s.register)
  const [setupKey, setSetupKey] = useState("")
  const [naziv, setNaziv] = useState("")
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleSubmit = async () => {
    setError(null)
    if (!setupKey.trim() || !naziv.trim()) {
      setError("Unesi setup ključ i naziv tableta.")
      return
    }
    setLoading(true)
    try {
      const uuid = generateUuid()
      const result = await registerDevice(setupKey.trim().toUpperCase(), uuid, naziv.trim())
      if (!result.success) {
        setError(result.poruka || "Registracija nije uspjela.")
        return
      }
      register(uuid, naziv.trim(), result.companyId, result.poslovnaJedinicaId, result.kasaId)
      navigate("/login", { replace: true })
    } catch (err) {
      const msg = err instanceof ApiClientError ? (err.detail || err.message) : "Greška pri registraciji."
      setError(msg)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="flex-1 flex items-center justify-center p-6">
      <div className="bg-white rounded-2xl shadow-lg p-8 max-w-md w-full">
        <h1 className="text-2xl font-bold text-slate-800 mb-2">SADEO Waiter</h1>
        <p className="text-slate-500 mb-6">Registracija tableta</p>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Setup ključ</label>
            <input type="text" value={setupKey} onChange={e => setSetupKey(e.target.value)} placeholder="TBLT-XXXX-XXXX" className="w-full border border-slate-300 rounded-lg px-3 py-3 text-lg uppercase focus:border-primary-500 focus:outline-none" />
          </div>
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-1">Naziv tableta</label>
            <input type="text" value={naziv} onChange={e => setNaziv(e.target.value)} placeholder="npr. Tablet šank 1" className="w-full border border-slate-300 rounded-lg px-3 py-3 text-lg focus:border-primary-500 focus:outline-none" />
          </div>
          {error && <div className="bg-red-50 border border-red-200 text-red-700 rounded-lg p-3 text-sm">{error}</div>}
          <button onClick={handleSubmit} disabled={loading} className="w-full bg-primary-600 text-white py-3 rounded-lg font-semibold text-lg disabled:bg-slate-300">
            {loading ? "Registrujem..." : "Registruj tablet"}
          </button>
        </div>
        <div className="text-center text-sm text-slate-400 mt-6">Setup ključ dobiješ od menadžera.</div>
      </div>
    </div>
  )
}
